import { ProjectModel } from 'shared/domain/project/types/model';
import { OrganizationModel } from 'shared/domain/organization/types/model';
import { getClientAdminPermission } from 'shared/domain/permissions/getClientAdminPermission';
import { isVisibleNoAccess } from 'shared/domain/role/isVisibleNoAccess';
import { ProjectPermissionDto } from 'shared/domain/user/types/inDto';
import { UserPermissionDto, UserRole } from 'shared/types/userRole';

export interface FilterProjectsForUserParams {
  projects: ProjectModel[];
  permissions: ProjectPermissionDto[];
  basePermissions: UserPermissionDto;
  organizationsMap: Map<string, OrganizationModel>;
}

/**
 * Filter projects for user considering:
 * - Org admin: sees all projects in their organization
 * - Super admin: sees everything
 * - Standard: only projects from permissions[] (excluding visible_no_access)
 *
 * Consistent with CreateProjectButton logic (uses getClientAdminPermission).
 */
export function filterProjectsForUser({
  projects,
  permissions,
  basePermissions,
  organizationsMap,
}: FilterProjectsForUserParams): ProjectModel[] {
  if (basePermissions.role === UserRole.superAdmin) {
    return projects;
  }

  const orgAdminOrgIds = getClientAdminPermission(
    basePermissions,
    organizationsMap
  );

  return projects.filter((project) => {
    if (orgAdminOrgIds.has(project.organizationId)) {
      return true;
    }
    return permissions.some(
      (perm) =>
        perm.project === project._id && !isVisibleNoAccess(perm.role)
    );
  });
}
